import { Box, FormControl } from "@primer/react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/ui/button";
import Modal from "../../../components/ui/modal";
import ModalActions from "../../../components/ui/modal/ModalActions";
import Text from "../../../components/ui/text";
import { useCommonContext } from "../../../contexts/common";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFoCaAnTruong } from "../../../models/response/thuc-don/IFoCaAnTruong";
import { actions } from "../../../state/actions/actionsWrapper";
import { RootState } from "../../../state/reducers";
import ComboboxCaAn from "../../../components/combobox-caan";
import { ComboboxTruong } from "../../../components/combobox-truong";

const DangKyCaAnEditModal = () => {
    const { status, editingData, foCaAnTruongsVm } = useSelector(
        (x: RootState) => x.thucDonWrapper.caAnTruong
    );
    const dispatch = useDispatch();
    const { dm_coso_id } = useCommonSelectedHook();
    const { translate } = useCommonContext();

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<IFoCaAnTruong>({
        defaultValues: editingData ? {
            ...editingData,
        } : {
            fo_caan_id: 0,
            dm_truong_id: 0
        },
    });

    const onSubmit = async (data: IFoCaAnTruong) => {
        // Check for duplicate entries
        const existingEntry = foCaAnTruongsVm.find(
            (entry) =>
                entry.fo_caan_id === data.fo_caan_id &&
                entry.dm_truong_id === data.dm_truong_id &&
                entry.id !== (data.id ?? 0)
        );

        if (existingEntry) {
            // Display an error message
            dispatch(
                actions.thucDonWrapper.caAnTruong.SAVE_ERROR(
                    "Đã có ca ăn được đăng ký cho trường này."
                )
            );
        } else {
            dispatch(
                actions.thucDonWrapper.caAnTruong.SAVE_START({
                    ...data,
                    id: data?.id ?? 0,
                    fo_caan_id: data?.fo_caan_id ?? 0,
                    dm_truong_id: data?.dm_truong_id ?? 0,
                })
            );
        }
    };

    return (
        <Modal
            isOpen
            title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
            onClose={() => {
                dispatch(actions.thucDonWrapper.caAnTruong.CLOSE_EDIT_MODAL(undefined));
            }}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "grid", gap: 2 }}>
                    <FormControl>
                        <FormControl.Label>
                            <Text text="Chọn ca ăn" />
                        </FormControl.Label>
                        <Controller
                            name="fo_caan_id"
                            control={control}
                            rules={{ 
                                required: "Vui lòng chọn ca ăn",
                                min: { value: 1, message: "Vui lòng chọn ca ăn" }
                            }}
                            render={({ field }) => (
                                <ComboboxCaAn
                                    width={"100%"}
                                    value={field.value}
                                    onValueChanged={field.onChange}
                                />
                            )}
                        />
                        {errors.fo_caan_id && (
                            <FormControl.Validation variant="error">
                                {errors.fo_caan_id.message}
                            </FormControl.Validation>
                        )}
                    </FormControl>

                    <FormControl>
                        <FormControl.Label>
                            <Text text="Chọn cấp học" />
                        </FormControl.Label>
                        <Controller
                            name="dm_truong_id"
                            control={control}
                            rules={{ 
                                required: "Vui lòng Chọn cấp học",
                                min: { value: 1, message: "Vui lòng Chọn cấp học" }
                            }}
                            render={({ field }) => (
                                <ComboboxTruong
                                    value={field.value}
                                    onValueChanged={field.onChange}
                                />
                            )}
                        />
                        {errors.dm_truong_id && (
                            <FormControl.Validation variant="error">
                                {errors.dm_truong_id.message}
                            </FormControl.Validation>
                        )}
                    </FormControl>
                </Box>
                <ModalActions>
                    <Button 
                        text='Base.Label.Close' 
                        onClick={() => {
                            dispatch(actions.thucDonWrapper.caAnTruong.CLOSE_EDIT_MODAL(undefined))
                        }} 
                    />
                    <Button 
                        text='Base.Label.Update' 
                        variant='primary' 
                        type='submit'
                        isLoading={status === ePageBaseStatus.is_saving}
                    />
                </ModalActions>
            </form>
        </Modal>
    );
};

export default DangKyCaAnEditModal;